export const REGISTER_FIELD_TITLE = 'title';
export const REGISTER_FIELD_COMPANY_NAME = 'companyName';
export const REGISTER_FIELD_COUNTRY = 'country';
export const REGISTER_FIELD_SOLD_TO = 'soldTo';
export const REGISTER_FIELD_BUSINESS_UNIT = 'businessUnit';
export const REGISTER_FIELD_FIRST_NAME = 'firstName';
export const REGISTER_FIELD_LAST_NAME = 'lastName';
export const REGISTER_FIELD_JOB_TITLE = 'jobTitle';
export const REGISTER_FIELD_BUSINESS_EMAIL = 'businessEmail';
export const REGISTER_FIELD_VERIFICATION_CODE = 'verificationCode';
export const REGISTER_FIELD_PHONE = 'phone';
export const REGISTER_FIELD_ORDER_HISTORY = 'orderHistory';
export const REGISTER_FIELD_CUSTOMER_NUMBER_OLD_SHOP = 'customerNumberOldShop';
export const REGISTER_FIELD_ADDITIONAL_NOTES = 'additionalNotes';
export const REGISTER_FIELD_CONSENT_ACCEPTED = 'consentAccepted';

// Query string parameter names used to pre-fill Sold-To / Business Unit when a visitor
// arrives via an invite link (e.g. shared by Sales/Support), since this is a public,
// unauthenticated sign-up page with no logged-in customer profile to read these from.
export const REGISTER_QUERY_PARAM_SOLD_TO = 'soldTo';
export const REGISTER_QUERY_PARAM_BUSINESS_UNIT = 'bu';

// Tracking number of the order a visitor tracked before signing up; the CSU resolves Sold-To and division from it for the sign-up mail.
export const REGISTER_QUERY_PARAM_TRACKING_NUMBER = 'trackingNumber';
